import React from 'react'
import { arrayOf, string } from 'prop-types'

import styles from './KeyFacts.module.scss'
import Type from '../Type'

const KeyFacts = ({ title, items }) => {
  if (!items || !items.length === 0) return null
  return (
    <div className={styles.KeyFacts}>
      <Type className={styles.Title} size={['body2', 'body3']} weight="medium">
        {title}
      </Type>
      <ul className={styles.List}>
        {items.map((item, i) => (
          <li key={`KeyFact-${i}`}>
            <Type size={['heading8', 'heading6']} weight="medium">
              {item.text}
            </Type>
          </li>
        ))}
      </ul>
    </div>
  )
}

KeyFacts.propTypes = {
  items: arrayOf(string),
  title: string
}

export default KeyFacts
